<template>
    <ul class="nav nav-tabs conversions-tabs">
        <li class="nav-item">
            <router-link :to="'/statistic/product/offer'" class="nav-link" exact><i class="fa fa-briefcase"></i> {{ $t('pages.by_offers') }}</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="'/statistic/product/country'" class="nav-link" exact><i class="fa fa-globe"></i> {{ $t('pages.by_country') }}</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="'/statistic/product/tag'" class="nav-link" exact><i class="fa fa-tags"></i> {{ $t('pages.by_category_product') }}</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="'/statistic/product/balance'" class="nav-link" exact><i class="fa fa-money"></i> {{ $t('pages.by_balance_currency') }}</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="'/statistic/product/orders_receipt'" class="nav-link" exact><i class="fa fa-exchange"></i> {{ $t('pages.orders_receipt') }}</router-link>
        </li>
    </ul>
</template>

<script>
  export default {
    name: 'ProductTabs'
  }
</script>



// WEBPACK FOOTER //
// ProductTabs.vue?a2f3804e